import './App.css'
import PrivateRoute from './Components/PrivateRoute'
import Home from './Pages/Home'
import Login from './Pages/Login'
import Initial from './Pages/Initial'
import AuthProvider from './Components/AuthProvider'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import FormRegister from './Pages/FormRegister'

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route
              path="/home"
              element={
                <PrivateRoute>
                  <Initial />
                </PrivateRoute>
              }
            />
            <Route
              path="/formulario"
              element={
                <PrivateRoute>
                  <FormRegister/>
                </PrivateRoute>
              }
            />
            <Route
              path="/apresentacao"
              element={
                <PrivateRoute>
                  <Home />
                </PrivateRoute>
              }
            />
          </Routes>
        </Router>
      </AuthProvider>
    </div>
  )
}

export default App
